import type { CellRenderersHook } from "@/features/integrations/shared/renderer/hooks/types";

/**
 * Registry mapping integration names to their cell renderers hooks.
 */
const cellRenderersHooksRegistry = new Map<string, CellRenderersHook>();

/**
 * Register a cell renderers hook for a specific integration in the job-sync module.
 * @param integrationName - The integration name (e.g., "indeed")
 * @param hook - The hook function that returns cell renderers
 */
export function registerJobSyncCellRenderersHook(
  integrationName: string,
  hook: CellRenderersHook
): void {
  const normalizedName = integrationName.toLowerCase();
  cellRenderersHooksRegistry.set(normalizedName, hook);
}

/**
 * Get the registered cell renderers hook for an integration.
 * @param integrationName - The integration name
 * @returns The registered hook function, or undefined if not registered
 */
export function getJobSyncCellRenderersHook(
  integrationName: string | undefined
): CellRenderersHook | undefined {
  if (!integrationName) return undefined;
  const normalizedName = integrationName.toLowerCase();
  return cellRenderersHooksRegistry.get(normalizedName);
}
